import {GIFT_CARD_DEFAULT_VALUE} from '~/CreateFabricGreetingCard/utils/constants';

export const selectReducer = ({eGiftCard}) => eGiftCard;

export const selectRetailer = (state) => selectReducer(state)?.retailer || '';
export const selectValue = (state) => selectReducer(state)?.value || null;

export const selectDefaultValue = (state) => {
  const retailer = selectRetailer(state);
  if (
    GIFT_CARD_DEFAULT_VALUE > retailer.max_value ||
    GIFT_CARD_DEFAULT_VALUE < retailer.min_value
  ) {
    return retailer.min_value;
  }
  return GIFT_CARD_DEFAULT_VALUE;
};

export const selectUserDisabled = (state) => selectReducer(state)?.userDisabled || false;
export const selectSystemDisabled = (state) => selectReducer(state)?.systemDisabled || false;

export const selectUserOrSystemDisabled = (state) =>
  selectUserDisabled(state) || selectSystemDisabled(state);

export const selectEGiftCardProducts = (state) => selectReducer(state)?.products;

export const selectIsDrawerOpen = (state) => selectReducer(state)?.isDrawerOpen || false;
